<template>
    <Layout is-crm @back="$router.back()">
        <Spinner v-if="loading" />
        <template v-if="flow.id">
            <div class="flow-details-page" style="max-width: 1140px; width: 100%; margin: 0 auto;">
                <Grid>
                    <Column span="4">
                        <header class="page__top">
                            <h1>{{ flow.label[$i18n.locale] }} flow</h1>
                        </header>
                        <code>{{ flow.slug }}</code>
                        <p>{{ flow.description[$i18n.locale] }}</p>
                    </Column>
                </Grid>
                <FlowGraph
                    v-if="transitions"
                    :flow="flow"
                    :states="states"
                    :transitions="transitions"
                />
            </div>
        </template>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import FlowGraph from '../../components/FlowGraph/FlowGraph';

import { fetchFlow, fetchFlowTransitions, fetchFlowStates } from '../../api/flows';

export default {
    name: 'FlowsPage',
    components: {
        Layout,
        Grid,
        Column,
        FlowGraph
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            flow: {},
            transitions: undefined,
            states: [],

            loading: false
        };
    },
    async created() {
        await this.fetch();
    },
    methods: {
        async fetch() {
            try {
                this.loading = true;
                [this.flow, this.transitions, this.states] = await Promise.all([
                    fetchFlow(this.id),
                    fetchFlowTransitions(this.id),
                    fetchFlowStates(this.id)
                ]);
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
